import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import { Message } from 'element-ui'
import i18n from '@/i18n'
import { getExtStatus, getUserCallInfo, userSign, hangUp, callOutCancel } from "@/api/CallCenter";
import { getYiXunAgentStatus, YiXunAgentLogin, YiXunAgentLogoff, YiXunQueuePause, YiXunHangup } from "@/util/YiXunCallCenter";
import { hasNewRecord,getsubjectdictbytype } from "@/api/basicApi";


Vue.use(Vuex);

const type = {
  CRM_MENU: 'CRM_MENU', // 运营系统菜单
  SIDEBAR_MENU: 'SIDEBAR_MENU', // 侧边栏导航
  SWITCH_MENU: 'SWITCH_MENU',
  REPORT_SEARCH: 'REPORT_SEARCH',
  CAMPUS_SEARCH: 'CAMPUS_SEARCH',
  OURSCHOOL_SEARCH: 'OURSCHOOL_SEARCH',
  YIXUN_REXTEND: 'YIXUN_REXTEND', // 易迅扩展字段
  CALL_STATUS: 'CALL_STATUS',
  AD_INFO: 'AD_INFO', // 公告消息
  SALECENTER_POTENTIAL: 'SALECENTER_POTENTIAL', // 销售中心-潜在学员搜索条件
  DingClass_Params :'DingClass_Params', //钉钉所在班级搜索条件
  DingStudent_Params :'DingStudent_Params', //钉钉所在学员搜索条件
  SALECENTER_READING: 'SALECENTER_READING', // 销售中心-在读学员搜索条件
  SALECENTER_HISTORICAL: 'SALECENTER_HISTORICAL', // 销售中心-历史学员搜索条件
  EC_READING: 'EC_READING', // 教务中心-在读学员搜索条件
  EC_HISTORICAL: 'EC_HISTORICAL', // 教务中心-历史学员搜索条件
  ORDERMANAGE_SEARCH: 'ORDERMANAGE_SEARCH', // 教务中心-历史学员搜索条件
  CLASSLESSON_SEARCH: 'CLASSLESSON_SEARCH', // 教务中心-班级课程搜索条件
  SIDER_CUSTOM: 'SIDER_CUSTOM', // 三级菜单
  READY_COURSE_DATE: 'READY_COURSE_DATE', //备课磨课日期
  IS_SHOW_CASE_INFO: 'IS_SHOW_CASE_INFO',//是否预览
  CANSE_MANAGE_SEARCH: 'CANSE_MANAGE_SEARCH',//案例管理
  HEADQUARTERS_SEARCH: 'HEADQUARTERS_SEARCH', //总部搜索
  City_Search: 'City_Search' //市搜索
}

function ChangeCallStatus(CallCenterStatus) {
  const names = [
    i18n.t('callCenter.notSignedIn'),
    i18n.t('callCenter.idle'),
    i18n.t('callCenter.busy'),
    i18n.t('callCenter.callAnswer')
  ];
  return {
      type: type.CALL_STATUS,
      CallCenterStatus,
      CallCenterStatusName: names[CallCenterStatus - 1],
  }
}

const state = {
  slideList: JSON.parse(localStorage.getItem("SideBarMenu")),
  // 改变表格的页数或当前页改变数据
  handleSize: 10,
  handleCurrent: 1,
  cardShow: true,
  activationPointCount:0,
  CallCenterStatusObj: {
    CallCenterStatus: 1,
    CallCenterStatusName: i18n.t('callCenter.notSignedIn')
  },
  CallOutRextendData: '',
  exportFileStatus: false, // 导出文件是否已读
  stuySubjectDict:JSON.parse(localStorage.getItem('stuySubjectDict') || '[]'),
  agentSubjectDict:JSON.parse(localStorage.getItem('agentSubjectDict') || '[]'),
  supervisorTeachers: [] // 督学师数据缓存，供全局共享
};
const actions = {
  slideListChange(context, value) {
    context.commit("slideListChange", value);
  },
  changeHandleSize(context, value) {
    context.commit("changeHandleSize", value);
  },
  changeHandleCurrent(contet, value) {
    contet.commit("changeHandleCurrent", value);
  },
  cardShow(context, value) {
    context.commit("cardShow", value);
  },
  setCallCenterStatus(context, data) {
    // context.commit("setCallCenterStatus", value);
    let CallCenterInfo = JSON.parse(localStorage.getItem("CRM_CALLCENTER_INFO") || '{}'),
      CallCenterType = CallCenterInfo.callCenterType;
    let CallCenterStatus = data;
    switch (CallCenterStatus) {
      case 'signIn': // 签入
        if ((CallCenterType === "3") || (CallCenterType === "4")) {
          userSign({ operate: 1, operateType: 1 }).then(ret => {
            getExtStatus().then(res => {
              if (res.code === 0) {
                if (res.data.statusId === 2) {
                  Message({
                    message: i18n.t('callCenter.signInSuccess'),
                    type: 'success'
                  });
                } else {
                  Message({
                    message: [i18n.t('callCenter.notSignedIn'), i18n.t('callCenter.idle'), i18n.t('callCenter.busy'), i18n.t('callCenter.callAnswer')][res.data.statusId - 1],
                    type: 'success'
                  });
                }
                //dispatch(ChangeCallStatus(res.data.statusId))
                context.commit("setCallCenterStatus", ChangeCallStatus(res.data.statusId));
              }
            })
          })
        } else if (CallCenterType === '5') {
          YiXunAgentLogin().then(ret => {
            getYiXunAgentStatus()
          })
        } else {
          console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
        }
        break;
      case 'signOut': // 签出
        if ((CallCenterType === "3") || (CallCenterType === "4")) {
          userSign({ operate: 2, operateType: 1 }).then(ret => {
            getExtStatus().then(res => {
              if (res.code === 0) {
                // dispatch(ChangeCallStatus(res.data.statusId))
                context.commit("setCallCenterStatus", ChangeCallStatus(res.data.statusId));
                if (res.data.statusId === 1) {
                  Message({
                    message: i18n.t('callCenter.signOutSuccess'),
                    type: 'success'
                  });
                } else {
                  Message({
                    message: [i18n.t('callCenter.notSignedIn'), i18n.t('callCenter.idle'), i18n.t('callCenter.busy'), i18n.t('callCenter.callAnswer')][res.data.statusId - 1],
                    type: 'success'
                  });
                }
              }
            })
          })
        } else if (CallCenterType === '5') {
          YiXunAgentLogoff().then(ret => {
            getYiXunAgentStatus()
          })
        } else {
          console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
        }
        break;
      case 'setIdle': // 置闲
        if ((CallCenterType === "3") || (CallCenterType === "4")) {
          userSign({ operate: 4, operateType: 2 }).then(ret => {
            getExtStatus().then(res => {
              if (res.code === 0) {
                if (res.data.statusId === 2) {
                  Message({
                    message: i18n.t('callCenter.setIdleSuccess'),
                    type: 'success'
                  });
                } else {
                  Message({
                    message: [i18n.t('callCenter.notSignedIn'), i18n.t('callCenter.idle'), i18n.t('callCenter.busy'), i18n.t('callCenter.callAnswer')][res.data.statusId - 1],
                    type: 'success'
                  });
                }
                context.commit("setCallCenterStatus", ChangeCallStatus(res.data.statusId));

              }
            })
          })
        } else if (CallCenterType === '5') {
          YiXunQueuePause(false).then(ret => {
            getYiXunAgentStatus()
          })
        } else {
          console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
        }
        break;
      case 'setBusy': // 置忙
        if ((CallCenterType === "3") || (CallCenterType === "4")) {
          userSign({ operate: 3, operateType: 2 }).then(ret => {
            getExtStatus().then(res => {
              if (res.code === 0) {
                if (res.data.statusId === 3) {
                  Message({
                    message: i18n.t('callCenter.setBusySuccess'),
                    type: 'success'
                  });
                } else {
                  Message({
                    message: [i18n.t('callCenter.notSignedIn'), i18n.t('callCenter.idle'), i18n.t('callCenter.busy'), i18n.t('callCenter.callAnswer')][res.data.statusId - 1],
                    type: 'success'
                  });
                }
                // dispatch(ChangeCallStatus(res.data.statusId))
                // this.ChangeCallStatus(res.data.statusId);
                context.commit("setCallCenterStatus", ChangeCallStatus(res.data.statusId));
              }
            })
          })
        } else if (CallCenterType === '5') {
          YiXunQueuePause(true).then(ret => {
            getYiXunAgentStatus()
          })
        } else {
          console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
        }
        break;
      case 'setHangup': // 挂断
        if ((CallCenterType === "3") || (CallCenterType === "4")) {
          if (CallCenterType - 3 === 0) {
            callOutCancel().then(ret => {
              if (ret.code === 0) {
                // dispatch({
                //   type: type.CALL_STATUS,
                //   CallCenterStatus: 2,
                //   CallCenterStatusName: '空闲中',
                // })
                this.CallCenterStatus = 2;
                this.CallCenterStatusName = '空闲中';
                context.commit("setCallCenterStatus", {
                  type: type.CALL_STATUS,
                  CallCenterStatus: 2,
                  CallCenterStatusName: '空闲中',
                });
              }
            })
          }
          hangUp({
            callCenterType: CallCenterType,
            extNo: CallCenterInfo.bindPhone
          }).then(ret => {
            if (ret.code === 0) {
              // dispatch({
              //     type: type.CALL_STATUS,
              //     CallCenterStatus: 2,
              //     CallCenterStatusName: '空闲中',
              // })
              context.commit("setCallCenterStatus", {
                type: type.CALL_STATUS,
                CallCenterStatus: 2,
                CallCenterStatusName: '空闲中',
              });
            }
          })
        } else if (CallCenterType === '5') {
          YiXunHangup(true).then(ret => {
            getYiXunAgentStatus()
          })
        } else {
          console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
        }
        break;
      case 'callOut': // 外呼
        context.commit("setCallCenterStatus", {
          type: type.CALL_STATUS,
          CallCenterStatus: 4,
          CallCenterStatusName: '通话中',
        });
        break;
      default:
        context.commit("setCallCenterStatus", {
          type: type.CALL_STATUS,
          CallCenterStatus: 1,
          CallCenterStatusName: '未签入',
        });
        break
    }
  },
  CallOutRextend() {
    context.commit("CallOutRextend", value);
  },
  TodoChangeCallStatus(context, value) {
    context.commit("TodoChangeCallStatus", value);
  },
  TodoChangeActivationPointCount(context, value) {
    context.commit("TodoChangeActivationPointCount", value);
  },
  /**
   * 公共查询导出文件是否已读状态
   * @value { Number } 1:查询是否存在导出记录未读 2:导出记录已读 3: 登录成功后查询
   * */
  async getExportFileStatus({ commit, dispatch }, value = 1) {
    const res = await hasNewRecord(value);
    console.log('查询导入日志》', res)
    if (res.code === 0) {
      // vuex中存储导出记录状态
      commit("setExportFileStatus", res.data)
      if (!res.data && value === 1) {
        setTimeout(() => {
          dispatch('getExportFileStatus');
        }, 5000)
      }
    }

  },
  // 获取学科配置study
  async getsubjectdict({ commit, dispatch }, type = 1) {
      getsubjectdictbytype({
        queryType: type,
        clientCode:'SQUIRREL_AI_HARDWARE_TOB',//固定项目一级code
        systemCode: 'CLIENT_SQUIRREL_AI_HARDWARE_DISTRIBUTOR',//固定项目二级code
      }).then(res=>{
        if(res.code == 0 && res.data){
          // subjectId <-> 语言名称映射
          // - 学习系统内部：1-8
          // - 代理商字典：6012xxx，需要按字典 oldId 显式映射，不能用尾号换算
          const SUBJECT_ID_LANG_MAP = {
            1: { zh: "英语", en: "English" },
            2: { zh: "数学", en: "Math" },
            3: { zh: "语文", en: "Chinese" },
            4: { zh: "物理", en: "Physics" },
            5: { zh: "化学", en: "Chemistry" },
            6: { zh: "生物", en: "Biology" },
            7: { zh: "地理", en: "Geography" },
            8: { zh: "科学", en: "Science" },
          };
          const AGENT_SUBJECT_TO_INTERNAL_ID_MAP = {
            6012003: 1,
            6012002: 2,
            6012001: 3,
            6012005: 4,
            6012004: 5,
            6012006: 6,
            6012007: 7,
            6012008: 8,
          };
          const translateSubjectNameById = (subjectId, fallback) => {
            const id = Number(subjectId);
            if (!id) return fallback;
            const baseId = AGENT_SUBJECT_TO_INTERNAL_ID_MAP[id] || id;
            const hit = SUBJECT_ID_LANG_MAP[baseId];
            if (!hit) return fallback;
            return i18n.locale === "en-US" ? hit.en : hit.zh;
          };

          let sujectList = []
          let list = []
          res.data.forEach(item => {
            const translatedName = translateSubjectNameById(item?.subjectId, item?.subjectName)
            if(type == 1){
              sujectList.push([item.subjectId, translatedName])
            }
            list.push({
              key: item.subjectId,
              value: translatedName
            })
          });
          if(type == 1){
            localStorage.setItem('stuySubjectDict',JSON.stringify(list))
            localStorage.setItem('sujectListDict',JSON.stringify(sujectList))
          }else{
            localStorage.setItem('agentSubjectDict',JSON.stringify(list))
          }
        }
      });

  },
};
const mutations = {
  slideListChange(state, value) {
    state.slideList = value;
  },
  changeHandleSize(state, value) {
    state.handleSize = value;
    console.log(state.handleSize);
  },
  changeHandleCurrent(state, value) {
    state.handleCurrent = value;
    console.log(state.handleCurrent);
  },
  cardShow(state, value) {
    let show = value;
    state.cardShow = show;
  },
  setCallCenterStatus(state, value) {
    state.CallCenterStatusObj = value;
  },
  CallOutRextend(state, value) {
    state.CallOutRextendData = value;
  },
  TodoChangeCallStatus(state, value) {
    state.CallCenterStatusObj = value;
  },
  TodoChangeActivationPointCount(state, value) {
    state.activationPointCount = value;
  },
  // 设置是否存在导出记录 value: true执行循环调用 false不执行
  async setExportFileStatus(state, value = false) {
    state.exportFileStatus = value;
  },
  setStuySubjectDict(state, value = false) {
    state.stuySubjectDict = value;
  },
  setAgentSubjectDict(state, value = false) {
    state.agentSubjectDict = value;
  },
  // 设置督学师数据
  setSupervisorTeachers(state, value) {
    state.supervisorTeachers = value;
  }
};
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

export default store;
